import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FilterOptions } from '@app-model/filter';
import { Program, ProgramPageableResponse, ProgramType } from '@app-model/program';
import { CheckedOption } from '@app-shared/utils';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ProgramService {
	constructor(private http: HttpClient) {}

	public getImageByUrl(url: string, imageName: string = 'image'): Promise<File> {
		const imageExtension = url.split('.').pop();
		return this.http
			.get(url, { responseType: 'blob' })
			.toPromise()
			.then(res => {
				return new File([res], `${imageName}.${imageExtension}`);
			});
	}

	getProgramTypes() {
		return this.http.get(`${environment.api}/program/listAllTypes`).pipe(
			map((response: any) => {
				const result: ProgramType[] = [];
				(response as ProgramType[]).forEach(programType => {
					result.push(Object.assign(new ProgramType(), programType));
				});
				return result;
			})
		);
	}

	getProgramTypeOptions() {
		return this.getProgramTypes().pipe(
			map(response => {
				const result: CheckedOption[] = [];
				const programTypes: ProgramType[] = response;
				programTypes.forEach(programType => {
					result.push(new CheckedOption(programType));
				});
				return result;
			})
		);
	}

	paginate(filter: FilterOptions): Observable<ProgramPageableResponse> {
		return this.http
			.post(`${environment.api}/adminProgram/listExternalPrograms`, filter)
			.pipe(map((response: ProgramPageableResponse) => response));
	}

	getProgram(id: number) {
		return this.http.get(`${environment.api}/adminProgram/${id}`).pipe(
			map((response: Program) => response),
			take(1)
		);
	}

	saveProgram(program: Program): Observable<ProgramPageableResponse> {
		return this.http
			.post(`${environment.api}/adminProgram/saveExternal`, program)
			.pipe(map((response: ProgramPageableResponse) => response));
	}

	uploadProgramFile(programId: string, file: File): Observable<{ success: boolean; }> {
		const formData = new FormData();
		formData.append('file', file);
		
		return this.http.post(`${environment.api}/adminProgram/${programId}/upload-content`, formData)
			.pipe(
				map((response: { success: boolean; }) => response)
			);
	}

	removeProgram(program: Program): Observable<ProgramPageableResponse> {
		return this.http
			.delete(`${environment.api}/adminProgram/delete/${program.id}`)
			.pipe(map((response: ProgramPageableResponse) => response));
	}
}
